import { errorUnlessOk, buildRequestWithAuth } from "./utils";
import environment from "~libs/environment";

export interface IdentidadPersona {
  nombres: string | null;
  apellido: string | null;
  /** Serializado como texto ISO. */
  fechaNacimiento: string | null;
  cuil: string | null;
}

/**
 * La respuesta trae los datos de una persona en la raíz y además la lista
 * completa de coincidencias. Verificado contra el contrato de CreditRisk, que
 * define `IdentidadResponse` heredando de `IdentidadPersona` y agregando
 * `Personas`.
 *
 * El casing camelCase no está configurado explícitamente en CreditRisk: viene
 * del default de `AddControllers().AddJsonOptions`, que arranca con
 * `JsonSerializerDefaults.Web`. Los campos se declaran nulables porque el
 * servicio no omite nulos y C# no garantiza lo contrario.
 */
export interface IdentidadResponse extends IdentidadPersona {
  personas: IdentidadPersona[];
}

const identidad = () => {
  return {
    getIdentidad: (
      documento: string,
      sexo: string
    ): Promise<IdentidadResponse> => {
      let request = buildRequestWithAuth("GET");
      return fetch(
        `${environment.creditRiskUrl}/personasfisicas/identidad?documento=${documento}&sexo=${sexo}`,
        request
      )
        .then(errorUnlessOk)
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
  };
};

export { identidad };
